import {PollResultsVisibility} from "@irati/types"
export const RESULTS_VISIBILITY_PROPERTY = "resultVisibility"

export const DEFAULT_OPTION = PollResultsVisibility.ResultVisibilityEveryone
export const EVERYONE_OPTION = (formatMessage) => ({
  label: formatMessage({id: "platform.fields.poll.visibility.option.toEveryone"}),
  name: formatMessage({id: "platform.fields.poll.visibility.option.toEveryone"}),
  value: PollResultsVisibility.ResultVisibilityEveryone
})

export const ADMIN_ONLY_OPTION = (formatMessage) => ({
  label: formatMessage({id: "platform.fields.poll.visibility.option.toAdminOnly"}),
  name: formatMessage({id: "platform.fields.poll.visibility.option.toAdminOnly"}),
  value: PollResultsVisibility.ResultVisibilityAdminsOnly
})

export const ADMIN_MANAGER_OPTION = (formatMessage) => ({
  label: formatMessage({id: "platform.fields.poll.visibility.option.toAdminManager"}),
  name: formatMessage({id: "platform.fields.poll.visibility.option.toAdminManager"}),
  value: PollResultsVisibility.ResultVisibilityAdminsAndManagers
})

export const DEFAULT_OPTIONS = (formatMessage) => [
  EVERYONE_OPTION(formatMessage),
  ADMIN_MANAGER_OPTION(formatMessage),
  ADMIN_ONLY_OPTION(formatMessage)
]
